<template>
  <div class="upload-page">
    <div v-if="isAdmin" class="tab_box">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        @click="changeUploadType(item)"
        :class="{ checkTab: upLoadType == item.type }"
      >
        <div>
          {{ item.name }}
          <span v-if="upLoadType == item.type"></span>
        </div>
      </div>
    </div>
    <div v-else class="tab_box">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        @click="changeUploadType(item)"
        :class="{ checkTab: upLoadType == item.type }"
      >
        <div>
          {{ item.name }}
          <span v-if="upLoadType == item.type"></span>
        </div>
      </div>
    </div>

    <div
      v-if="upLoadType == 'article'"
      class="uploadeContentBox settingBox text_box_1 hasBotBorder"
    >
      <div class="label menuText">
        输入内容
      </div>
      <van-field
        :readonly="article_id != ''"
        class="original_link"
        v-model="link"
        rows="5"
        type="textarea"
        placeholder="请将已复制的微信文章链接，粘贴到此处"
      />
    </div>
    <div
      v-if="upLoadType == 'originate'"
      class="uploadeContentBox settingBox  "
      style="padding-bottom:0"
    >
      <div class="label menuText">
        标题描述
      </div>

      <div class="original_link_box">
        <van-field
          class="original_link"
          v-model="article_title"
          rows="5"
          type="textarea"
          maxlength="40"
          placeholder="最多输入40个字"
        />
      </div>
    </div>
    <div
      class="settingBox quill-editor_box hasBotBorder"
      v-if="upLoadType == 'originate'"
    >
      <div class="label menuText">
        文章内容
      </div>
      <quill-editor
        ref="myTextEditor"
        :content="content"
        :options="editorOption"
        @change="onEditorChange($event)"
      ></quill-editor>
    </div>
    <div
      v-if="upLoadType == 'imgOrVideo' || upLoadType == 'article'"
      class="uploadeContentBox settingBox"
    >
      <div class="label menuText">
        朋友圈配文
      </div>
      <van-field
        class="original_link"
        v-model="artcsummary"
        rows="5"
        type="textarea"
        placeholder="请输入朋友圈配文"
      />
    </div>
    <div v-if="upLoadType == 'imgOrVideo'">
      <div class="settingBox">
        <div class="label menuText">
          上传图片/视频
        </div>
        <van-uploader
          v-if="!article_id"
          ref="uploader"
          class="my_uploader"
          :max-count="fileMax"
          :before-read="beforeRead"
          :after-read="readFile"
          accept="accept"
          v-model="fileList"
          multiple="multiple"
        >
          <img src="./img/photograph.png" alt />
        </van-uploader>
        <p v-if="!article_id" class="uploadImgTip">最多上传9张图/一个视频</p>
        <div class="imgBox" v-if="article_id">
          <img v-for="(item, index) in imgList" :key="index" :src="item" alt />
        </div>
      </div>
    </div>
    <div
      v-if="
        (upLoadType == 'imgOrVideo' &&
          fileList[0] &&
          fileList[0].file.type.indexOf('image') == -1) ||
          editType == 'VOD'
      "
      class="uploadeContentBox settingBox  "
      style="padding-bottom:0"
    >
      <div class="label menuText">
        标题描述
      </div>

      <div class="original_link_box">
        <van-field
          class="original_link"
          v-model="article_title"
          rows="5"
          type="textarea"
          maxlength="40"
          placeholder="最多输入40个字"
        />
      </div>
    </div>

    <div v-if="isAdmin && upLoadType == 'imgOrVideo'">
      <div class="settingBox linkUrl hasBotBorder">
        <div class="label menuText">
          跳转链接
        </div>
        <van-field v-model="jumpurl" placeholder="在此输入跳转链接" />
      </div>
    </div>
    <div class="settingBox CategoryBox hasBotBorder">
      <div class="label menuText">
        选择分类标签
      </div>
      <van-tag
        v-for="(item, index) in typeList"
        :key="index"
        :data-id="item.id"
        round
        :class="{ chekedTag: checkedLable.includes(item.firstTag) }"
        @click="setCategory($event, item, index)"
        type="primary"
        >{{ item.firstTag }}</van-tag
      >
      <!-- 二级标签 -->
      <div v-if="isAdmin">
        <div v-if="typeListSeconds.length > 0" class="label menuText borderTop">
          选择二级标签(可选)
        </div>
        <van-tag
          v-for="(item, index) in typeListSeconds"
          :data-id="item"
          :key="index"
          :class="{ chekedTag: checkedLableSec.includes(item) }"
          @click="setCategorySec($event, item, index)"
          round
          type="primary"
          >{{ item }}</van-tag
        >
      </div>
    </div>

    <div v-if="isAdmin" class="settingBox CategoryBox hasBotBorder">
      <div class="label menuText">
        选择人设
      </div>
      <van-tag
        v-for="(item, index) in characterList"
        :key="index"
        :class="{ chekedTag: checkedCharacter.includes(item.name) }"
        @click="setCharacter($event, item, index)"
        round
        type="primary"
        >{{ item.name }}</van-tag
      >
    </div>

    <div v-if="isAdmin" class="settingBox layoutBox hasBotBorder">
      <div class="label menuText">
        选择板式
      </div>
      <van-radio-group v-model="layout">
        <van-radio
          checked-color="#FF6927"
          v-for="(item, idx) in layoutTypes"
          :key="idx"
          :name="item.code"
          >{{ item.name }}</van-radio
        >
      </van-radio-group>
    </div>
    <div v-if="isAdmin">
      <div class="settingBox ">
        <div class="base_num">
          <van-field
            v-model="redNum"
            :readonly="article_id ? true : false"
            type="digit"
            label="输入阅读量："
          />
          <van-field
            v-model="shareNum"
            :readonly="article_id ? true : false"
            type="digit"
            label="输入转发量："
          />
        </div>
      </div>
    </div>
    <div class="centerBox settingBox ">
      <van-checkbox checked-color="#FF6927" v-model="field2">
        公开
        <span>（选择公开，您上传的文章将会被别人看到）</span>
      </van-checkbox>
    </div>

    <div v-if="isAdmin">
      <div class="settingBox setTop ">
        <van-checkbox checked-color="#FF6927" v-model="theTop"
          >置顶</van-checkbox
        >
      </div>
    </div>

    <div class="btn_group">
      <van-button class="btn" plain @click="cancel()">取消</van-button>
      <van-button class="btn confirmBtn" @click="upLoadArticl">
        {{ article_id ? "保存" : "上传" }}
      </van-button>
    </div>
    <div class="tip">
      <p class="tipTitle">上传说明</p>
      <p>1.本文内容编辑整理均来源于网络，版权归原作者所有</p>
      <p>2.如有涉及侵权，请及时联系我们，我们会立即删除，特此声明。</p>
    </div>
    <van-dialog v-model="infoBox" @confirm="gotoUploadedList">
      <img src="./img/bin.png" alt />
      <div class="close" @click="reSetData">
        <img src="./img/close.png" alt />
      </div>
      <div class="tipTitle">
        <p>上传成功！</p>
      </div>
      <div class="textContent"></div>
    </van-dialog>
    <van-overlay :show="showPercentageBox">
      <div class="wrapper">
        <div class="block">
          <van-loading color="#FF6927" size="80px" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import URL from "@/api/api";
import {  Dialog, Toast } from "vant";
import axios from "axios";
export default {
  name: "articleUpload",
  data() {
    return {
      showPercentageBox: false,
      origin: "https://www.bjnfbk.com" || location.origin,
      // origin: location.origin,
      uploadurl:"",
      upLoadType: "article",
      tabList: [
        { name: "上传文章", type: "article" },
        { name: "上传图片/视频", type: "imgOrVideo" }
      ],
      article_id: "",
      isAdmin: false,
      link: "",
      article_title: "",
      openId: "",
      infoBox: false,
      field2: false,
      redNum: 0,
      shareNum: 0,
      textForImg: "",
      articleCategory: "",
      jumpurl: "",
      layout: "L1_1",
      fileList: [],
      imgurl1: null,
      imgurl2: null,
      imgurl3: null,
      imgurl4: null,
      imgurl5: null,
      imgurl6: null,
      imgurl7: null,
      imgurl8: null,
      imgurl9: null,
      imgList: [],
      fileListForUpload: null,
      theTop: false, // 置顶
      content: "",
      artcsummary: "",
      fileMax: 9,
      editorOption: {
        placeholder: "请在这里输入",
        modules: {
          toolbar: [
            ["image"] //上传图片、上传视频
          ]
        }
      },
      uploadUrlList: [],
      characterList: [
        {
          id: "0",
          name: "高净值"
        },
        {
          id: "1",
          name: "夕阳红"
        },
        {
          id: "2",
          name: "家有儿女"
        },
        {
          id: "3",
          name: "单身贵族"
        },
        {
          id: "4",
          name: "职业保险代理人"
        }
      ],
      typeList: [
        {
          id:"DK00",
          firstTag:"贷款",
          secondTag:[
              { id: "DK01", tag: "贷款知识" },
            { id: "DK02", tag: "合规宣导" },
          ]
        },
        {
          id: "BX00",
          firstTag: "保险",
          secondTag: [
            { id: "BX01", tag: "行业动态" },
            { id: "BX02", tag: "保险理念" },
            { id: "BX03", tag: "保险增员" },
            { id: "BX04", tag: "保障理财" },
            { id: "BX05", tag: "保险避坑" },
            { id: "BX06", tag: "重疾理赔知识" },
            { id: "BX07", tag: "健康险购买指南及评测" },
            { id: "BX08", tag: "养老产品购买指南" },
            { id: "BX09", tag: "儿童险购买指南及评测" },
            { id: "BX10", tag: "车险购买指南及评测" },
            { id: "BX11", tag: "产品解读" },
            { id: "BX12", tag: "投保指南" },
            { id: "BX13", tag: "保险案例故事" }
          ]
        },
        {
          id: "CJ00",
          firstTag: "财经",
          secondTag: [
            { id: "CJ01", tag: "财经新闻" },
            { id: "CJ02", tag: "行业动态" },
            { id: "CJ03", tag: "个人理财规划" },
            { id: "CJ04", tag: "理财技巧" },
            { id: "CJ05", tag: "保障理财" }
          ]
        },
        {
          id: "JK00",
          firstTag: "健康",
          secondTag: [
            { id: "JK01", tag: "减肥塑身" },
            { id: "JK02", tag: "健康养生" },
            { id: "JK03", tag: "用药知识" },
            { id: "JK04", tag: "就医问诊指南" },
            { id: "JK05", tag: "滋补食疗" },
            { id: "JK06", tag: "健身搏击" },
            { id: "JK07", tag: "健康险购买指南及评测" },
            { id: "JK08", tag: "养老产品购买指南" },
            { id: "JK08", tag: "食品安全" }
          ]
        },
        {
          id: "JY00",
          firstTag: "教育",
          secondTag: [
            { id: "JY01", tag: "儿童艺术" },
            { id: "JY02", tag: "育儿百科" },
            { id: "JY03", tag: "作业辅导及习惯养成" },
            { id: "JY04", tag: "儿童险购买指南及评测" }
          ]
        },
        {
          id: "LY00",
          firstTag: "旅游",
          secondTag: [
            { id: "LY01", tag: "旅游攻略" },
            { id: "LY02", tag: "摄影技巧" },
            { id: "LY03", tag: "自驾游" },
            { id: "LY04", tag: "出行小贴士" }
          ]
        },
        {
          id: "QC00",
          firstTag: "汽车",
          secondTag: [
            { id: "QC01", tag: "用车小知识" },
            { id: "QC02", tag: "购车指南" },
            { id: "QC03", tag: "汽车评测" },
            { id: "QC04", tag: "车险购买指南及评测" },
            { id: "QC05", tag: "出行小贴士" },
            { id: "QC06", tag: "自驾游" }
          ]
        },
        {
          id: "SH00",
          firstTag: "生活",
          secondTag: [
            { id: "SH01", tag: "正能量" },
            { id: "SH02", tag: "美食制作" },
            { id: "SH03", tag: "种草美食" },
            { id: "SH04", tag: "美妆" },
            { id: "SH05", tag: "居家小技巧" },
            { id: "SH06", tag: "理财技巧" },
            { id: "SH07", tag: "两性话题" },
            { id: "SH08", tag: "宠物健康" },
            { id: "SH09", tag: "宠物饲养" },
            { id: "SH10", tag: "儿童摄影" },
            { id: "SH11", tag: "摄影技巧" },
            { id: "SH12", tag: "出行小贴士" },
            { id: "SH13", tag: "时事资讯" },
            { id: "SH14", tag: "穿搭指南" },
            { id: "SH15", tag: "新闻早报" }
          ]
        },
        {
          id: "HD00",
          firstTag: "互动",
          secondTag: [
            { id: "HD01", tag: "黄历" },
            { id: "HD02", tag: "心理测试" },
            { id: "HD03", tag: "星座运势" },
            { id: "HD04", tag: "趣味一刻" }
          ]
        },
        {
          id: "ZC00",
          firstTag: "职场",
          secondTag: [
            { id: "ZC01", tag: "全职妈妈职业规划" },
            { id: "ZC02", tag: "职场感悟与吐槽" },
            { id: "ZC03", tag: "职场管理技能" },
            { id: "ZC04", tag: "成长书单" }
          ]
        }
      ], // 一级标签
      typeListSecond: [], // 一级标签的基础上包含的所有二级标签
      typeListSeconds: [],
      selectSecondTag: [],
      checkedLable: [], // 选中的一级标签
      checkedLableSec: [], // 选中的二级标签
      checkedCharacter: [], // 选中的人设
      secondTagData: [],
      layoutTypes: [
        { name: "仅文字", code: "L1_0" },
        { name: "文字+3图", code: "L1_3" },
        { name: "文字+大图（大V、视频、大图）", code: "L2_1" },
        { name: "文字+错位图（2张以上）", code: "L1_S" },
        { name: "文字右边配略缩图", code: "L1_1" },
        { name: "文字+9宫格", code: "L1_9" },
        { name: "视频轮播区域", code: "L3_N" },
        { name: "顶部轮播广告", code: "L4_APSWIPE" },
        { name: "页面中插播广告", code: "L4_ADOVE" },
        { name: "页面中插播广告弹出广告", code: "L4_ADINER" },
        { name: "弹出广告", code: "L4_ADOVER" }
      ],
      article_type: "image",
      upLoadStatus: false,
      editType: "",
      postList: []
    };
  },
  mounted() {
    if (location.hostname === 'dtfcloud.com') {
      this.uploadurl="https://dtfcloud.com/minio-pic/ufc"
    }else{
      this.uploadurl="https://jzt.dtfcloud.com/minio-pic/ufc"
    }
    this.editType = this.$route.query.artcType;
    this.openId = sessionStorage.getItem("openId");
    if (this.$route.query.article_id) {
      this.article_id = this.$route.query.article_id;
      this.setPostList();
    }
    this.checkPower();
  },
  methods: {
    cancel() {
      this.link = "";
    },
    changeUploadType(obj) {
      this.upLoadType = obj.type;
      this.reSetData();
    },
    upLoadArticl() {
      var that = this;
      if (this.checkedCharacter.length === 0 && this.isAdmin === true) {
        Toast("请选择人设");
        return;
      }
      if (this.checkedLable.length === 0) {
        Toast("请选择分类标签");
        return;
      }
      if (this.article_id) {
        Dialog.confirm({
          title: "提示",
          message: "您确认要提交修改么？"
        })
          .then(() => {
            // on confirm
            that.upDate();
          })
          .catch(() => {
            // on cancel
          });
      } else {
        if (this.upLoadType == "article") {
          this.fileList = [];
          (this.content = ""), this.createArticle();
        } else if (this.upLoadType == "imgOrVideo") {
          this.uploadImgOrVideoFile(this.fileListForUpload);
        } else {
          this.upLoadArticleByWrite();
        }
      }
    },
    //重置数据
    reSetData() {
      this.infoBox = false;
      if (this.upLoadType == "imgOrVideo") {
        this.content = "";
        this.link = "";
        this.layout = "L1_9";
      } else {
        this.layout = "L1_1";
        this.fileList = [];
      }
      this.article_title = "";
      this.redNum = 0;
      this.shareNum = 0;
      this.theTop = false;
      this.field2 = false;
      this.checkedLable = [];
      this.checkedLableSec = [];
      this.checkedCharacter = [];
      this.typeListSeconds = [];
      this.artcsummary = "";
      this.linkUrl = "";
      this.postList = [];
    },

    onEditorChange({ editor, html, text }) {
      //富文本编辑器  文本改变时 设置字段值
      this.content = html;
    },
    setCategorySec(e, str, index) {
      if (this.checkedLableSec.includes(str)) {
        this.checkedLableSec = this.checkedLableSec.filter(
          item => item !== str
        );
      } else {
        this.checkedLableSec.push(str);
      }
      this.setPostList();
    },
    setCategory(e, str, index) {
      if (this.checkedLable.includes(str.firstTag)) {
        // 删除选中的二级标签
        str.secondTag.forEach(v => {
          if (this.checkedLableSec.includes(v.tag)) {
            this.checkedLableSec.splice(
              this.checkedLableSec.findIndex(item => item === v.tag),
              1
            );
          }
        });
        // 删除选中的一级标签
        this.checkedLable.splice(
          this.checkedLable.findIndex(item => item === str.firstTag),
          1
        );
        // 重置总共二级标签列表
        this.typeListSeconds = [];
        this.typeList.forEach(v => {
          if (this.checkedLable.includes(v.firstTag)) {
            v.secondTag.forEach(v2 => {
              this.typeListSeconds.push(v2.tag);
            });
          }
        });
      } else {
        // 增加一级标签
        this.checkedLable.push(str.firstTag);
        // 增加二级标签
        str.secondTag.forEach(ele => {
          this.typeListSecond.push(ele);
          // 去重添加，防止重复
          if (!this.typeListSeconds.includes(ele.tag)) {
            this.typeListSeconds.push(ele.tag);
          }
        });
      }
      this.setPostList();
    },
    setCharacter(e, str, index) {
      if (this.checkedCharacter.includes(str.name)) {
        this.checkedCharacter.splice(
          this.checkedCharacter.findIndex(item => item === str.name),
          1
        );
      } else {
        this.checkedCharacter.push(str.name);
      }
    },
    setPostList() {
      this.postList = [];
      this.typeList.forEach(v => {
        if (this.checkedLable.includes(v.firstTag)) {
          let list = [];
          v.secondTag.forEach(v2 => {
            if (this.checkedLableSec.includes(v2.tag)) {
              list.push(v2.id);
            }
          });
          this.postList.push({ firstLabel: v.firstTag, secondaryLabel: list });
        }
      });
    },
    getData() {
       this.$fetchPost(URL.getUploadDetails.url, {
        artcId: this.$route.query.article_id,
        artcType: this.$route.query.artcType
      }).then(res => {
        if (res.data.code == 20000) {
          if (
            this.$route.query.artcType == "PAW" ||
            this.$route.query.artcType == "VOD"
          ) {
            this.upLoadType = "imgOrVideo";
            this.artcsummary = res.data.data.artcsummary;
          }
          if (this.$route.query.artcType == "ARTUPLD") {
            this.upLoadType = "article";
            this.artcsummary = res.data.data.friendSummary;
          }
          if (this.$route.query.artcType == "ARTORIG") {
            this.upLoadType = "originate";
            this.artcsummary = res.data.data.artcsummary;
          }
          this.link = res.data.data.artcUrl;
          this.field1 = res.data.data.field1;
          this.field2 = res.data.data.field2 == "0" ? true : false;
          this.theTop = res.data.data.isTop == "1" ? true : false;
          this.redNum = res.data.data.viewcount;
          this.shareNum = res.data.data.fwdcount;
          this.layout = res.data.data.layouttype;
          this.jumpurl = res.data.data.jumpurl;
          this.content = res.data.data.content;
          //等到后台接口重写以后，二级标签才能进行添加（留着空行的位置就是已选二级标签的列表）
          let list2 = [];
          let list1 = [];
          if (res.data.data.labels.length !== 0) {
            res.data.data.labels.forEach(v => {
              list2.push(v.firstLabel);
              v.secondaryLabel.forEach(v2 => {
                list1.push(v2);
              });
            });
          }
          this.checkedLable = list2;
          // 将二级标签展示出来
          this.typeList.forEach(v => {
            if (this.checkedLable.includes(v.firstTag)) {
              v.secondTag.forEach(v2 => {
                if (!this.typeListSeconds.includes(v2.tag)) {
                  this.typeListSeconds.push(v2.tag);
                }
              });
            }
          });
          this.typeList.forEach(v => {
            v.secondTag.forEach(v2 => {
              if (list1.includes(v2.id)) {
                if (!this.checkedLableSec.includes(v2.tag)) {
                  this.checkedLableSec.push(v2.tag);
                }
              }
            });
          });
          this.checkedCharacter = res.data.data.character;
          // 判断 如果不是管理员，将二级标签和性格选择的删除
          if (this.isAdmin === false) {
            this.checkedLableSec = [];
            this.checkedCharacter = [];
          }
          this.imgurl1 = res.data.data.imgurl1;
          this.imgurl2 = res.data.data.imgurl2;
          this.imgurl3 = res.data.data.imgurl3;
          this.imgurl4 = res.data.data.imgurl4;
          this.imgurl5 = res.data.data.imgurl5;
          this.imgurl6 = res.data.data.imgurl6;
          this.imgurl7 = res.data.data.imgurl7;
          this.imgurl8 = res.data.data.imgurl8;
          this.imgurl9 = res.data.data.imgurl9;
          this.vodurl = res.data.data.vodurl;
          this.article_title = res.data.data.title;
          let list = [];
          for (let key in res.data.data) {
            if (
              key.includes("imgurl") &&
              res.data.data[key] &&
              key != "faceimgurl"
            ) {
              list.push(res.data.data[key]);
            }
          }
          this.imgList = list;
          // 重置postList
          this.setPostList();
        }
      });
    },
    checkPower() {
      this.$fetchPost(URL.checkAuthority.url, {
        unionid: localStorage.getItem("unionid")
      }).then(res => {
        if (res) {
          if (res.data.data) {
            this.isAdmin = true;
            this.tabList = [
              { name: "上传文章", type: "article" },
              { name: "上传图片/视频", type: "imgOrVideo" },
              { name: "原创文章", type: "originate" }
            ];
          } else {
            this.isAdmin = false;
            this.tabList = [
              { name: "上传文章", type: "article" },
              { name: "上传图片/视频", type: "imgOrVideo" }
            ];
          }
          if (this.article_id != "") {
            this.getData();
          }
        }
      });
    },
    validateInfo() {
      if (this.upLoadType == "article") {
        /* eslint-disable*/
        const reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
        if (this.link == "") {
          Toast("请输入文章链接！");
          return false;
        }
        if (!reg.test(this.link)) {
          Toast("文章链接格式不正确，请重新输入！");
          return false;
        }
        return true;
      }
      if (this.upLoadType == "imgOrVideo") {
        if (this.artcsummary == "") {
          Toast("请输入朋友圈配文");
          return false;
        }
        if (this.fileList.length == "0") {
          Toast("请上传文件！");
          return false;
        }
        if (this.layout == "" && this.isAdmin) {
          Toast("请选则文章板式！");
          return false;
        }
        return true;
      }
      if (this.upLoadType == "originate") {
        if (this.article_title == "") {
          Toast("请输入文章标题");
          return false;
        }
        if (this.content == "") {
          Toast("请输入原创文章内容");
          return false;
        }
        return true;
      }
    },
    //将base64转换为文件对象
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    beforeRead(file) {
      if (file instanceof Array && file.length) {
        if (file[0].type.indexOf("image") > -1) {
          this.layout = "L1_9";
          for (let i = 0; i < file.length; i++) {
            if (file[i].type.includes("video")) {
              Toast("不能同时上传图片和视频");
              this.fileList = [];
              return false;
            }
          }
          this.fileMax = 9; //图片最多上传9张
          return true;
        } else {
          this.fileMax = 1; //视频只能长传一个
          for (let i = 0; i < file.length; i++) {
            if (file[i].type.includes("image")) {
              Toast("不能同时上传图片和视频");
              this.fileList = [];
              return false;
            }
          }
          return true;
        }
      } else {
        if (this.fileList.length > 1) {
          if (file.type.includes("video")) {
            Toast("不能同时上传图片和视频");
            return false;
          } else {
            return true;
          }
        } else {
          if (file.type.includes("image")) {
            this.fileMax = 9; //图片最多上传9张
          } else {
            this.fileMax = 1;
            this.layout = "L2_1";
          }
          return true;
        }
      }
    },
    readFile(e) {
      let that = this;
      that.fileListForUpload = null;
      that.fileListForUpload = new FormData();
      if (that.fileList.length > 0) {
        that.fileList.forEach(item => {
          that.fileListForUpload.append("files", item.file); //第一个参数字符串可以填任意命名，第二个根据对象属性来找到file
        });
      } else {
        if (e instanceof Array && e.length) {
          // 判断是否是多图上传 多图则循环添加进去
          e.forEach(item => {
            that.fileListForUpload.append("files", item.file); //第一个参数字符串可以填任意命名，第二个根据对象属性来找到file
          });
        } else {
          that.fileListForUpload.append("files", e.file);
        }
      }


      return true;
    },
    createArticle() {
      if (this.link !== "") {
        /* eslint-disable*/
        const reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
        if (!reg.test(this.link)) {
          Toast("文章链接格式不正确，请重新输入！");
          return false;
        }
        Toast.loading({
          message: "加载中...",
          duration: 0,
          forbidClick: true
        });
        this.$fetchPost(URL.beforUploade.url, {
          openid: this.openId,
          refLink: this.link
        }).then(res => {
          if (res.data == "0") {
            this.$fetchPost(URL.uploadArticleByUrl.url, {
              artcUrl: this.link,
              openid: this.openId,
              unionid: localStorage.getItem("unionid"),
              field2: this.field2 ? "0" : "1",
              viewCount: this.redNum,
              fwdCount: this.shareNum,
              types: this.checkedLable,
              layouttype: this.layout,
              friendSummary: this.artcsummary,
              isTop: this.theTop ? "1" : "0",
              labels: this.postList,
              character: this.checkedCharacter
            }).then(res => {
              Toast.clear();
              if (res.data.msg === "成功" && res.data.success) {
                this.infoBox = true;
              } else {
                Toast("上传失败，请重试");
              }
            });
          } else {
            Toast("您已经上传过该篇文章");
          }
        });
      } else {
        Toast("文章链接不能为空");
      }
    },
    //  图文视频上传
    uploadImgOrVideoFile(file) {
      if (!this.validateInfo()) {
        return;
      }
      this.showPercentageBox = true;
      let that = this; 

      axios({
      method: 'post',
      url:process.env.VUE_APP_API+"/ufc/api/activities/imgUploads?useType=articleimg",
      data:this.fileListForUpload,
      dataType: "jsons",
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': '*'
      },
    })
      .then(res => { 
        if (res.data.code === 20000) {
            let num = 0;
            for (let x = 0; x < this.fileList.length; x++) {
              num++;
              this.fileList[x].upLoadUrl =
                that.uploadurl + res.data.data[x].replace("/home", '');
            }
            if (num > this.fileList.length - 1) {
              this.uploadImgOrVideo();
              setTimeout(function() {
                that.percentageNum = 0;
              }, 3000);
            }
          }
      })
      .catch(() => {
        this.showPercentageBox = false
      });

      // $.ajax({
      //   url:
      //     // this.origin +
      //     process.env.VUE_APP_API+
      //     "/ufc/api/activities/imgUploads?useType=articleimg",
      //   type: "POST",
      //   dataType: "json",
      //   processData: false, // 不处理数据
      //   contentType: false, // 不设置内容类型
      //   data: this.fileListForUpload,
      //   // xhr: function() {
      //   //   //ajax进度条，直接拿过去就可以用
      //   //   var xhr = $.ajaxSettings.xhr();
      //   //   if (xhr.upload) {
      //   //     that.showPercentageBox = true;
      //   //     xhr.upload.addEventListener(
      //   //       "progress",
      //   //       function(e) {
      //   //         var loaded = e.loaded; //已经上传大小情况
      //   //         var tot = e.total; //附件总大小
      //   //         let per = Math.floor((100 * loaded) / tot);
      //   //         if (per == "100") { 
      //   //           that.showPercentageBox = false;
      //   //         } 
      //   //       },
      //   //       false
      //   //     );
      //   //     return xhr;
      //   //   }
      //   // },
      //   success: res => {
      //     if (res.code === 20000) {
      //       let num = 0;
      //       for (let x = 0; x < this.fileList.length; x++) {
      //         num++;
      //         this.fileList[x].upLoadUrl =
      //           that.uploadurl + res.data[x].replace("/home", '');
      //       }
      //       if (num > this.fileList.length - 1) {
      //         this.uploadImgOrVideo();
      //         setTimeout(function() {
      //           that.percentageNum = 0;
      //         }, 3000);
      //       }
      //     }
      //   },
      //   complete: res => {this.showPercentageBox = false;}
      // });
    },
    uploadImgOrVideo() {
      let that = this;
      let params = {};
      if (this.fileList[0].file.type.indexOf("image") > -1) {
        params = {
          openid: this.openId, //用户的openid
          unionid: localStorage.getItem("unionid"), //用户的unionid
          contenttype: "PAW", //'SND-音频  PAW-图和文    VOD-视频',
          istop: that.theTop ? "1" : "0", //是否置顶 '1-置顶  0-不置顶',
          artcsummary: that.artcsummary, //朋友圈配文
          layouttype: this.layout, //版式布局
          viewcount: that.redNum, //初始浏览次数
          fwdcount: that.shareNum, //初始转发次数
          types: this.checkedLable,
          imgurl9: this.fileList[8] ? this.fileList[8].upLoadUrl : "", //配图9
          imgurl8: this.fileList[7] ? this.fileList[7].upLoadUrl : "", //配图8
          imgurl7: this.fileList[6] ? this.fileList[6].upLoadUrl : "", //配图7
          imgurl6: this.fileList[5] ? this.fileList[5].upLoadUrl : "", //配图6
          imgurl5: this.fileList[4] ? this.fileList[4].upLoadUrl : "",
          imgurl4: this.fileList[3] ? this.fileList[3].upLoadUrl : "",
          imgurl3: this.fileList[2] ? this.fileList[2].upLoadUrl : "",
          imgurl2: this.fileList[1] ? this.fileList[1].upLoadUrl : "",
          imgurl1: this.fileList[0] ? this.fileList[0].upLoadUrl : "",
          // vodurl: "", //视频
          // vodfiletype: "", //视频文件类型
          // sndurl: "", //音频
          // sndfiletype: "", //音频文件类型
          // faceimgurl: "", //音视频封面
          jumpurl: this.jumpurl, //跳转链接  '通常是顶部广告用的多，点击后跳转到新连接',
          field1: "", //' ATIC-文章，CRTN-动画，DOYIN-抖音，PIC-海报',
          field2: that.field2 ? "0" : "1", //是否公开 0---公开；1---不公开
          labels: this.postList,
          character: this.checkedCharacter
        };
      } else {
        params = {
          openid: this.openId, //用户的openid
          unionid: localStorage.getItem("unionid"), //用户的unionid
          contenttype: "VOD", //'SND-音频  PAW-图和文    VOD-视频',
          istop: that.theTop ? "1" : "0", //是否置顶 '1-置顶  0-不置顶',
          artcsummary: that.artcsummary, //朋友圈配文
          layouttype: this.layout, //版式布局
          viewcount: that.redNum, //初始浏览次数
          fwdcount: that.shareNum, //初始转发次数
          vodurl: that.fileList[0].upLoadUrl, //视频
          types: this.checkedLable,
          vodfiletype: "", //视频文件类型
          jumpurl: this.jumpurl, //跳转链接  '通常是顶部广告用的多，点击后跳转到新连接',
          field1: "", //' ATIC-文章，CRTN-动画，DOYIN-抖音，PIC-海报',
          field2: that.field2 ? "0" : "1", //是否公开 0---公开；1---不公开
          title: that.article_title,
          labels: this.postList,
          character: this.checkedCharacter
        };
      }
      that.$fetchPost(URL.uploadFile.url, params).then(res => {
        if (res.data.code==20000) {
          this.infoBox = true;
        }
      });
    },
    //原创上传
    upLoadArticleByWrite() {
      let data = {
        //  artcid,//文章id
        //  agtid,//作者（代理人）id
        openid: this.openId, //用户的openid
        title: this.article_title, //标题
        content: this.content, //内容
        viewCount: this.redNum, //初始浏览次数   -- 管理员
        fwdCount: this.shareNum, //初始转发次数   -- 管理员
        types: this.checkedLable, //文章的多个分类
        isTop: this.theTop ? "1" : "0", //文章是否置顶 (0--不置顶；1--置顶)
        artctype: "ORIG", // 文章是否原创 UPLD—上传     ORIG—原创
        isdel: "", //文章是否删除   0—未删除   1—删除
        layouttype: this.layout, //版式布局
        unionid: localStorage.getItem("unionid"), //unionid
        field2: this.field2 ? "0" : "1", //是否公开 0---公开；1---不公开
        labels: this.postList,
        character: this.checkedCharacter
      };
      if (!this.validateInfo()) {
        return;
      }
      
      this.$fetchPost(URL.uploadOriginalArticle.url, data).then(res => {
        this.infoBox = true;
      });
    },
    //更新、修改
    upDate() {
      let that = this;
      let params = {};
      if (
        this.$route.query.artcType == "PAW" ||
        this.$route.query.artcType == "VOD"
      ) {
        params = {
          artcId: this.article_id,
          artcType: this.$route.query.artcType,
          openid: this.openId, //用户的openid
          unionid: this.openId, //用户的unionid
          contenttype: this.$route.query.artcType, //'SND-音频  PAW-图和文    VOD-视频',
          istop: this.theTop ? "1" : "0", //是否置顶 '1-置顶  0-不置顶',
          artcsummary: this.artcsummary, //朋友圈配文
          layouttype: this.layout, //版式布局
          viewcount: this.redNum, //初始浏览次数
          fwdcount: this.shareNum, //初始转发次数
          types: this.checkedLable,
          imgurl9: this.fileList[8] ? this.fileList[8].upLoadUrl : "", //配图9
          imgurl8: this.fileList[7] ? this.fileList[7].upLoadUrl : "", //配图8
          imgurl7: this.fileList[6] ? this.fileList[6].upLoadUrl : "", //配图7
          imgurl6: this.fileList[5] ? this.fileList[5].upLoadUrl : "", //配图6
          imgurl5: this.fileList[4] ? this.fileList[4].upLoadUrl : "",
          imgurl4: this.fileList[3] ? this.fileList[3].upLoadUrl : "",
          imgurl3: this.fileList[2] ? this.fileList[2].upLoadUrl : "",
          imgurl2: this.fileList[1] ? this.fileList[1].upLoadUrl : "",
          imgurl1: this.fileList[0] ? this.fileList[0].upLoadUrl : "",
          // vodurl: "", //视频
          // vodfiletype: "", //视频文件类型
          // sndurl: "", //音频
          // sndfiletype: "", //音频文件类型
          // faceimgurl: "", //音视频封面
          vtitle: this.article_title,
          jumpurl: this.jumpurl, //跳转链接  '通常是顶部广告用的多，点击后跳转到新连接',
          field1: "", //' ATIC-文章，CRTN-动画，DOYIN-抖音，PIC-海报',
          field2: that.field2 ? "0" : "1", //是否公开 0---公开；1---不公开
          labels: this.postList,
          character: this.checkedCharacter
        };
      } else if (this.$route.query.artcType == "ARTUPLD") {
        params = {
          artcId: this.article_id,
          artcType: this.$route.query.artcType,
          openid: this.openId, //用户的openid
          unionid: this.openId, //用户的unionid
          contenttype: this.$route.query.artcType, //'SND-音频  PAW-图和文    VOD-视频',
          isTop: this.theTop ? "1" : "0", //是否置顶 '1-置顶  0-不置顶',
          friendSummary: this.artcsummary, //朋友圈配文
          layouttype: this.layout, //版式布局
          viewcount: this.redNum, //初始浏览次数
          fwdcount: this.shareNum, //初始转发次数
          content: this.content, //视频
          types: this.checkedLable,
          vodfiletype: "", //视频文件类型
          jumpurl: this.jumpurl, //跳转链接  '通常是顶部广告用的多，点击后跳转到新连接',
          field1: "", //' ATIC-文章，CRTN-动画，DOYIN-抖音，PIC-海报',
          field2: this.field2 ? "0" : "1", //是否公开 0---公开；1---不公开
          labels: this.postList,
          character: this.checkedCharacter
        };
      } else {
        params = {
          title: this.article_title,
          artcId: this.article_id,
          artcType: this.$route.query.artcType,
          openid: this.openId, //用户的openid
          unionid: this.openId, //用户的unionid
          contenttype: this.$route.query.artcType, //'SND-音频  PAW-图和文    VOD-视频',
          isTop: this.theTop ? "1" : "0", //是否置顶 '1-置顶  0-不置顶',
          artcsummary: this.artcsummary, //朋友圈配文
          layouttype: this.layout, //版式布局
          viewcount: this.redNum, //初始浏览次数
          fwdcount: this.shareNum, //初始转发次数
          content: this.content, //视频
          types: this.checkedLable,
          vodfiletype: "", //视频文件类型
          jumpurl: this.jumpurl, //跳转链接  '通常是顶部广告用的多，点击后跳转到新连接',
          field1: "", //' ATIC-文章，CRTN-动画，DOYIN-抖音，PIC-海报',
          field2: this.field2 ? "0" : "1", //是否公开 0---公开；1---不公开
          labels: this.postList,
          character: this.checkedCharacter
        };
      }
      this.$fetchPost(URL.updateFile.url, data).then(res => {
        if (res.data.code == "20000") {
          this.infoBox = true;
        }
      });

    },
    //跳转到上传列表
    gotoUploadedList() {
      this.$router.push({
        path: "/uploadedList"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.upload-page {
  background: #fff;
  .borderTop {
    border-top: 4px solid #eee;
  }
  .menuText {
    color: #1a1a1a;
    height: 48px;
    font-size: 16px;
    font-weight: 500;
    span {
      img {
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-top: -6px;
        vertical-align: middle;
      }
    }
  }
  .settingBox {
    padding: 0px 16px;
    /deep/ .van-icon-photograph {
      color: #8c68fe;
    }
  }
  .hasBotBorder {
    border-bottom: 4px solid #f6f6f6;
  }
  /deep/ .my_uploader.van-uploader {
    .van-uploader__wrapper {
      .van-uploader__preview {
        // width: 30%;
        width: 102px;
        height: 102px;
        margin: 5px 5px 0 0;
        .van-image {
          width: 100px;
          height: 100px;
        }
        img {
          width: 102px;
          height: 102px;
        }
      }
      .van-uploader__input-wrapper {
        margin: 5px;
        width: 102px;
        height: 102px;
        border-radius: 4px;
        background: #f6f6f6;
        .van-uploader__input {
          width: 102px;
          height: 102px;
        }
        img {
          width: 32px;
          height: 28px;
          margin: 36px 35px 0 35px;
        }
      }
      // :nth-child(3n-1) {
      //   margin: 5px 5%;
      // }
    }
  }

  .label {
    font-size: 16px;
    line-height: 46px;
    margin-top: 8px;
  }
  /deep/ .van-radio__label {
    margin-top: 2px;
  }
  .tab_box {
    display: flex;
    padding: 0 16px;
    font-size: 18px;
    color: #666;

    div {
      width: 30%;
      display: flex;
      line-height: 42px;
      div {
        width: 4.2em;
        position: relative;
        display: flex;
        line-height: 42px;
        margin-top: 8px;
        span {
          display: block;
          position: absolute;
          width: 16px;
          height: 3px;
          background: #ff6927;
          left: 50%;
          margin-left: -10px;
          border-radius: 2px;
          bottom: 2px;
        }
      }
    }
    :nth-child(2) {
      width: 40%;
      div {
        width: auto;
        text-align: center;
        margin: 0px auto;
        margin-top: 8px;
      }
    }
    :nth-child(3) {
      justify-content: flex-end;
    }
    .checkTab {
      color: #ff6927;
      font-weight: bold;
    }
  }
  // .van-tabs {
  //   padding: 0 16px;
  //   /deep/.van-tabs__nav.van-tabs__nav--line {
  //     justify-content: flex-start;
  //     .van-tab {
  //       // display: -webkit-box;
  //       font-size: 16px;
  //       font-weight: 500;
  //       padding: 0;
  //       width: 33%;
  //       flex: none;
  //     }
  //     .van-tab--active {
  //       font-weight: bold;
  //     }
  //     .unClick {
  //       pointer-events: none;
  //       display: none;
  //     }
  //   }
  //   /deep/ .van-hairline--top-bottom::after,
  //   .van-hairline-unset--top-bottom::after {
  //     border-width: 0;
  //   }
  // }
  .uploadeContentBox {
    padding-bottom: 12px;
    .original_link_box {
      position: relative;
      .tip_text {
        position: absolute;
        width: 100%;
        bottom: 10px;
        font-size: 14px;
        background: transparent;
        left: -16px;
        color: #ccc;

        text-align: right;
      }
    }
    .original_link {
      padding: 0;
      border-radius: 4px;
      /deep/ .van-field__control {
        padding: 8px;
        background-color: #f8f8f8;
      }
    }

    /deep/ .van-cell:not(:last-child)::after {
      border: none;
    }
  }

  .text_box_1 {
    padding-bottom: 20px;
  }

  .CategoryBox {
    padding-bottom: 8px;
    /deep/ .van-tag {
      font-size: 14px;
      line-height: 30px;
      height: 30px;
      padding: 0 12px;
      margin-right: 12px;
      margin-bottom: 12px;
      background: transparent;
      border: 1px solid #f6f6f6;
      color: #333;
    }
    .chekedTag {
      background: #ff6927;
      color: #fff;
    }
  }
  .layoutBox {
    .van-radio {
      margin-bottom: 20px;
      font-size: 14px;
    }
  }
  .quill-editor_box {
    padding-bottom: 16px;
  }

  div.base_num {
    display: flex;
    justify-content: space-between;
    // margin: 12px 0;
    padding: 14px 0;
    .van-cell.van-field {
      font-size: 16px;
      background: #fff;
      height: 32px;
      color: #1a1a1a;
      font-weight: 500;
      line-height: 32px;
      padding: 0 0 0 0px;
      width: 158px;
      border-radius: 4px;
      /deep/ .van-field__label {
        width: 100x;
        margin-right: 0;
        span {
          display: block;
          width: 100%;
        }
      }
      /deep/ .van-field__body {
        input {
          background: #f6f6f6;
          padding-left: 10px;
          font-weight: normal;
        }
      }
    }
    .van-cell::after {
      border: none;
    }
  }
  .linkUrl {
    padding-bottom: 20px;
    .van-cell.van-field {
      font-size: 14px;
      background: #f6f6f6;
      height: 32px;
      line-height: 32px;
      padding: 0 0 0 12px;
      border-radius: 4px;
    }
  }
  .fileType {
    // padding-bottom: 2px;
    .typeSpan {
      font-size: 16px;
      line-height: 32px;
      padding: 0 12px;
      margin-right: 12px;
      margin-bottom: 8px;
      // background: #f6f6f6;
      color: #666;
      height: 32px;
      display: inline-block;
      border-radius: 4px;
    }
    .checked_article_type {
      color: #ff6927;
      font-weight: bold;
      // color: #fff;
    }
  }

  .uploadImgTip {
    font-size: 11px;
    color: #131313;
    margin-bottom: 16px;
  }

  .centerBox,
  .setTop {
    // padding: 10px 16px;
    display: flex;
    line-height: 46px;
    height: 46px;
    color: #ccc;
    padding: 0px 16px;
    margin-top: 8px;
    padding-bottom: 8px;
    // justify-content: flex-end;
    /deep/ .van-checkbox__label {
      font-size: 14px;
      margin-top: 2px;
      span {
        font-size: 12px;
        color: #f56c6c;
      }
    }
  }
  /deep/ .btn_group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    margin-bottom: 20px;
    margin-top: 24px;
    .btn.van-button {
      width: 116px;
      line-height: 44px;
      font-size: 16px;
      margin-left: 24px;
      color: #ff6927;
      border-color: #ff6927;
      border-radius: 22px;
    }
    .btn.confirmBtn {
      color: #fff;
      position: relative;
      border: none;
      height: 46px;
      margin-right: 24px;
      width: 118px;
      // border-color: #FF6927;
      background: linear-gradient(90deg, #ff6521 0%, #ffa041 100%);
      box-shadow: 0px 3px 6px #f1b1b1;
      // box-shadow: 0px 3px 10px #9cd3e8;
    }
  }
  .tip {
    padding: 0 16px;
    color: #b3b3b3;
    font-size: 14px;
    margin: 30px 0;
    padding-bottom: 40px;
    p {
      line-height: 32px;
      &:nth-child(1) {
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
      }
    }
  }
  /deep/ .van-dialog {
    //  .van-dialog__header{
    //    line-height: 44px;
    //    padding-top: 0
    //  }
    width: 270px;
    border-radius: 3px;
    padding-bottom: 30px;
    text-align: center;
    img {
      width: 54px;
      // height: 54px;
      margin: 0 auto;
      margin-top: 50px;
      border-radius: 3px;
    }
    .close {
      width: 22px;
      height: 22px;
      position: absolute;
      top: 10px;
      right: 10px;
      img {
        width: 22px;
        height: 22px;
        margin: 0;
      }
    }
    .tipTitle {
      text-align: center;
      margin-top: 18px;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .textContent {
      text-align: center;
      width: 80%;
      margin: 0 auto;
      font-size: 13px;
      color: #6e6e6e;
      padding-bottom: 27px;
    }
    .van-dialog__footer {
      width: 190px;
      margin: 0 auto;
    }
    .van-button.van-dialog__confirm {
      background: #ff6927;
      width: 190px;
      color: #fff;
      display: block;

      border-radius: 22px;
      font-size: 14px;
      line-height: 44px;
      height: 44px;
    }
  }
  .imgBox {
    display: flex;
    flex-wrap: wrap;
    img {
      width: 100px;
      height: 100px;
      margin: 4px;
      align-items: center;
      display: flex;

      background: #ccc;
    }
  }
  /deep/ .ql-container.ql-snow {
    height: 100px;
  }
}
/deep/.van-hairline--top::after {
  border: none;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 80px;
  background-color: none;
}
</style>
